/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as SignInRouteRouteImport } from './routes/sign-in/route'
import { Route as AppIndexRouteRouteImport } from './routes/_app/index/route'
import { Route as AppAlbumsIndexRouteImport } from './routes/_app/albums/index'
import { Route as AppAlbumsAlbumIdRouteImport } from './routes/_app/albums/$albumId'
import { Route as AppArtistsIndexRouteImport } from './routes/_app/artists/index'
import { Route as AppArtistsArtistIdRouteImport } from './routes/_app/artists/$artistId'
import { Route as AppDiscoverIndexRouteImport } from './routes/_app/discover/index'
import { Route as AppDownloadsIndexRouteImport } from './routes/_app/downloads/index'
import { Route as AppFavoritesIndexRouteImport } from './routes/_app/favorites/index'
import { Route as AppFoldersIndexRouteImport } from './routes/_app/folders/index'
import { Route as AppHistoryIndexRouteImport } from './routes/_app/history/index'
import { Route as AppMostPlayedIndexRouteImport } from './routes/_app/most-played/index'
import { Route as AppPlaylistsIndexRouteImport } from './routes/_app/playlists/index'
import { Route as AppPlaylistsPlaylistIdRouteImport } from './routes/_app/playlists/$playlistId'
import { Route as AppPlaylistsGenerateRouteImport } from './routes/_app/playlists/generate'
import { Route as AppPlaylistsGenerateSeedRouteImport } from './routes/_app/playlists/generate-seed'
import { Route as AppPlaylistsNewRouteImport } from './routes/_app/playlists/new'
import { Route as AppRecentlyAddedIndexRouteImport } from './routes/_app/recently-added/index'
import { Route as AppSearchIndexRouteImport } from './routes/_app/search/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppTracksIndexRouteImport } from './routes/_app/tracks/index'
import { Route as AppTracksTrackIdRouteImport } from './routes/_app/tracks/$trackId'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRouteRoute = SignInRouteRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRouteRoute = AppIndexRouteRouteImport.update({
  id: '/',
  path: '',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAlbumsIndexRoute = AppAlbumsIndexRouteImport.update({
  id: '/albums/',
  path: '/albums/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAlbumsAlbumIdRoute = AppAlbumsAlbumIdRouteImport.update({
  id: '/albums/$albumId',
  path: '/albums/$albumId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppArtistsIndexRoute = AppArtistsIndexRouteImport.update({
  id: '/artists/',
  path: '/artists/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppArtistsArtistIdRoute = AppArtistsArtistIdRouteImport.update({
  id: '/artists/$artistId',
  path: '/artists/$artistId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDiscoverIndexRoute = AppDiscoverIndexRouteImport.update({
  id: '/discover/',
  path: '/discover/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDownloadsIndexRoute = AppDownloadsIndexRouteImport.update({
  id: '/downloads/',
  path: '/downloads/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFavoritesIndexRoute = AppFavoritesIndexRouteImport.update({
  id: '/favorites/',
  path: '/favorites/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFoldersIndexRoute = AppFoldersIndexRouteImport.update({
  id: '/folders/',
  path: '/folders/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHistoryIndexRoute = AppHistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMostPlayedIndexRoute = AppMostPlayedIndexRouteImport.update({
  id: '/most-played/',
  path: '/most-played/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPlaylistsIndexRoute = AppPlaylistsIndexRouteImport.update({
  id: '/playlists/',
  path: '/playlists/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPlaylistsPlaylistIdRoute = AppPlaylistsPlaylistIdRouteImport.update({
  id: '/playlists/$playlistId',
  path: '/playlists/$playlistId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPlaylistsGenerateRoute = AppPlaylistsGenerateRouteImport.update({
  id: '/playlists/generate',
  path: '/playlists/generate',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPlaylistsGenerateSeedRoute =
  AppPlaylistsGenerateSeedRouteImport.update({
    id: '/playlists/generate-seed',
    path: '/playlists/generate-seed',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppPlaylistsNewRoute = AppPlaylistsNewRouteImport.update({
  id: '/playlists/new',
  path: '/playlists/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRecentlyAddedIndexRoute = AppRecentlyAddedIndexRouteImport.update({
  id: '/recently-added/',
  path: '/recently-added/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSearchIndexRoute = AppSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTracksIndexRoute = AppTracksIndexRouteImport.update({
  id: '/tracks/',
  path: '/tracks/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTracksTrackIdRoute = AppTracksTrackIdRouteImport.update({
  id: '/tracks/$trackId',
  path: '/tracks/$trackId',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRouteRoute
  '/sign-in': typeof SignInRouteRoute
  '/albums/$albumId': typeof AppAlbumsAlbumIdRoute
  '/artists/$artistId': typeof AppArtistsArtistIdRoute
  '/playlists/$playlistId': typeof AppPlaylistsPlaylistIdRoute
  '/playlists/generate': typeof AppPlaylistsGenerateRoute
  '/playlists/generate-seed': typeof AppPlaylistsGenerateSeedRoute
  '/playlists/new': typeof AppPlaylistsNewRoute
  '/tracks/$trackId': typeof AppTracksTrackIdRoute
  '/albums/': typeof AppAlbumsIndexRoute
  '/artists/': typeof AppArtistsIndexRoute
  '/discover/': typeof AppDiscoverIndexRoute
  '/downloads/': typeof AppDownloadsIndexRoute
  '/favorites/': typeof AppFavoritesIndexRoute
  '/folders/': typeof AppFoldersIndexRoute
  '/history/': typeof AppHistoryIndexRoute
  '/most-played/': typeof AppMostPlayedIndexRoute
  '/playlists/': typeof AppPlaylistsIndexRoute
  '/recently-added/': typeof AppRecentlyAddedIndexRoute
  '/search/': typeof AppSearchIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/tracks/': typeof AppTracksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRouteRoute
  '/sign-in': typeof SignInRouteRoute
  '/albums/$albumId': typeof AppAlbumsAlbumIdRoute
  '/artists/$artistId': typeof AppArtistsArtistIdRoute
  '/playlists/$playlistId': typeof AppPlaylistsPlaylistIdRoute
  '/playlists/generate': typeof AppPlaylistsGenerateRoute
  '/playlists/generate-seed': typeof AppPlaylistsGenerateSeedRoute
  '/playlists/new': typeof AppPlaylistsNewRoute
  '/tracks/$trackId': typeof AppTracksTrackIdRoute
  '/albums': typeof AppAlbumsIndexRoute
  '/artists': typeof AppArtistsIndexRoute
  '/discover': typeof AppDiscoverIndexRoute
  '/downloads': typeof AppDownloadsIndexRoute
  '/favorites': typeof AppFavoritesIndexRoute
  '/folders': typeof AppFoldersIndexRoute
  '/history': typeof AppHistoryIndexRoute
  '/most-played': typeof AppMostPlayedIndexRoute
  '/playlists': typeof AppPlaylistsIndexRoute
  '/recently-added': typeof AppRecentlyAddedIndexRoute
  '/search': typeof AppSearchIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/tracks': typeof AppTracksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/sign-in': typeof SignInRouteRoute
  '/_app/': typeof AppIndexRouteRoute
  '/_app/albums/$albumId': typeof AppAlbumsAlbumIdRoute
  '/_app/artists/$artistId': typeof AppArtistsArtistIdRoute
  '/_app/playlists/$playlistId': typeof AppPlaylistsPlaylistIdRoute
  '/_app/playlists/generate': typeof AppPlaylistsGenerateRoute
  '/_app/playlists/generate-seed': typeof AppPlaylistsGenerateSeedRoute
  '/_app/playlists/new': typeof AppPlaylistsNewRoute
  '/_app/tracks/$trackId': typeof AppTracksTrackIdRoute
  '/_app/albums/': typeof AppAlbumsIndexRoute
  '/_app/artists/': typeof AppArtistsIndexRoute
  '/_app/discover/': typeof AppDiscoverIndexRoute
  '/_app/downloads/': typeof AppDownloadsIndexRoute
  '/_app/favorites/': typeof AppFavoritesIndexRoute
  '/_app/folders/': typeof AppFoldersIndexRoute
  '/_app/history/': typeof AppHistoryIndexRoute
  '/_app/most-played/': typeof AppMostPlayedIndexRoute
  '/_app/playlists/': typeof AppPlaylistsIndexRoute
  '/_app/recently-added/': typeof AppRecentlyAddedIndexRoute
  '/_app/search/': typeof AppSearchIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/tracks/': typeof AppTracksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/albums/$albumId'
    | '/artists/$artistId'
    | '/playlists/$playlistId'
    | '/playlists/generate'
    | '/playlists/generate-seed'
    | '/playlists/new'
    | '/tracks/$trackId'
    | '/albums/'
    | '/artists/'
    | '/discover/'
    | '/downloads/'
    | '/favorites/'
    | '/folders/'
    | '/history/'
    | '/most-played/'
    | '/playlists/'
    | '/recently-added/'
    | '/search/'
    | '/settings/'
    | '/tracks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/albums/$albumId'
    | '/artists/$artistId'
    | '/playlists/$playlistId'
    | '/playlists/generate'
    | '/playlists/generate-seed'
    | '/playlists/new'
    | '/tracks/$trackId'
    | '/albums'
    | '/artists'
    | '/discover'
    | '/downloads'
    | '/favorites'
    | '/folders'
    | '/history'
    | '/most-played'
    | '/playlists'
    | '/recently-added'
    | '/search'
    | '/settings'
    | '/tracks'
  id:
    | '__root__'
    | '/_app'
    | '/sign-in'
    | '/_app/'
    | '/_app/albums/$albumId'
    | '/_app/artists/$artistId'
    | '/_app/playlists/$playlistId'
    | '/_app/playlists/generate'
    | '/_app/playlists/generate-seed'
    | '/_app/playlists/new'
    | '/_app/tracks/$trackId'
    | '/_app/albums/'
    | '/_app/artists/'
    | '/_app/discover/'
    | '/_app/downloads/'
    | '/_app/favorites/'
    | '/_app/folders/'
    | '/_app/history/'
    | '/_app/most-played/'
    | '/_app/playlists/'
    | '/_app/recently-added/'
    | '/_app/search/'
    | '/_app/settings/'
    | '/_app/tracks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  SignInRouteRoute: typeof SignInRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/albums/': {
      id: '/_app/albums/'
      path: '/albums'
      fullPath: '/albums/'
      preLoaderRoute: typeof AppAlbumsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/albums/$albumId': {
      id: '/_app/albums/$albumId'
      path: '/albums/$albumId'
      fullPath: '/albums/$albumId'
      preLoaderRoute: typeof AppAlbumsAlbumIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/artists/': {
      id: '/_app/artists/'
      path: '/artists'
      fullPath: '/artists/'
      preLoaderRoute: typeof AppArtistsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/artists/$artistId': {
      id: '/_app/artists/$artistId'
      path: '/artists/$artistId'
      fullPath: '/artists/$artistId'
      preLoaderRoute: typeof AppArtistsArtistIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/discover/': {
      id: '/_app/discover/'
      path: '/discover'
      fullPath: '/discover/'
      preLoaderRoute: typeof AppDiscoverIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/downloads/': {
      id: '/_app/downloads/'
      path: '/downloads'
      fullPath: '/downloads/'
      preLoaderRoute: typeof AppDownloadsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/favorites/': {
      id: '/_app/favorites/'
      path: '/favorites'
      fullPath: '/favorites/'
      preLoaderRoute: typeof AppFavoritesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/folders/': {
      id: '/_app/folders/'
      path: '/folders'
      fullPath: '/folders/'
      preLoaderRoute: typeof AppFoldersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/history/': {
      id: '/_app/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof AppHistoryIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/most-played/': {
      id: '/_app/most-played/'
      path: '/most-played'
      fullPath: '/most-played/'
      preLoaderRoute: typeof AppMostPlayedIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/playlists/': {
      id: '/_app/playlists/'
      path: '/playlists'
      fullPath: '/playlists/'
      preLoaderRoute: typeof AppPlaylistsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/playlists/$playlistId': {
      id: '/_app/playlists/$playlistId'
      path: '/playlists/$playlistId'
      fullPath: '/playlists/$playlistId'
      preLoaderRoute: typeof AppPlaylistsPlaylistIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/playlists/generate': {
      id: '/_app/playlists/generate'
      path: '/playlists/generate'
      fullPath: '/playlists/generate'
      preLoaderRoute: typeof AppPlaylistsGenerateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/playlists/generate-seed': {
      id: '/_app/playlists/generate-seed'
      path: '/playlists/generate-seed'
      fullPath: '/playlists/generate-seed'
      preLoaderRoute: typeof AppPlaylistsGenerateSeedRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/playlists/new': {
      id: '/_app/playlists/new'
      path: '/playlists/new'
      fullPath: '/playlists/new'
      preLoaderRoute: typeof AppPlaylistsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/recently-added/': {
      id: '/_app/recently-added/'
      path: '/recently-added'
      fullPath: '/recently-added/'
      preLoaderRoute: typeof AppRecentlyAddedIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/search/': {
      id: '/_app/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AppSearchIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tracks/': {
      id: '/_app/tracks/'
      path: '/tracks'
      fullPath: '/tracks/'
      preLoaderRoute: typeof AppTracksIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tracks/$trackId': {
      id: '/_app/tracks/$trackId'
      path: '/tracks/$trackId'
      fullPath: '/tracks/$trackId'
      preLoaderRoute: typeof AppTracksTrackIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppIndexRouteRoute: typeof AppIndexRouteRoute
  AppAlbumsAlbumIdRoute: typeof AppAlbumsAlbumIdRoute
  AppArtistsArtistIdRoute: typeof AppArtistsArtistIdRoute
  AppPlaylistsPlaylistIdRoute: typeof AppPlaylistsPlaylistIdRoute
  AppPlaylistsGenerateRoute: typeof AppPlaylistsGenerateRoute
  AppPlaylistsGenerateSeedRoute: typeof AppPlaylistsGenerateSeedRoute
  AppPlaylistsNewRoute: typeof AppPlaylistsNewRoute
  AppTracksTrackIdRoute: typeof AppTracksTrackIdRoute
  AppAlbumsIndexRoute: typeof AppAlbumsIndexRoute
  AppArtistsIndexRoute: typeof AppArtistsIndexRoute
  AppDiscoverIndexRoute: typeof AppDiscoverIndexRoute
  AppDownloadsIndexRoute: typeof AppDownloadsIndexRoute
  AppFavoritesIndexRoute: typeof AppFavoritesIndexRoute
  AppFoldersIndexRoute: typeof AppFoldersIndexRoute
  AppHistoryIndexRoute: typeof AppHistoryIndexRoute
  AppMostPlayedIndexRoute: typeof AppMostPlayedIndexRoute
  AppPlaylistsIndexRoute: typeof AppPlaylistsIndexRoute
  AppRecentlyAddedIndexRoute: typeof AppRecentlyAddedIndexRoute
  AppSearchIndexRoute: typeof AppSearchIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppTracksIndexRoute: typeof AppTracksIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIndexRouteRoute: AppIndexRouteRoute,
  AppAlbumsAlbumIdRoute: AppAlbumsAlbumIdRoute,
  AppArtistsArtistIdRoute: AppArtistsArtistIdRoute,
  AppPlaylistsPlaylistIdRoute: AppPlaylistsPlaylistIdRoute,
  AppPlaylistsGenerateRoute: AppPlaylistsGenerateRoute,
  AppPlaylistsGenerateSeedRoute: AppPlaylistsGenerateSeedRoute,
  AppPlaylistsNewRoute: AppPlaylistsNewRoute,
  AppTracksTrackIdRoute: AppTracksTrackIdRoute,
  AppAlbumsIndexRoute: AppAlbumsIndexRoute,
  AppArtistsIndexRoute: AppArtistsIndexRoute,
  AppDiscoverIndexRoute: AppDiscoverIndexRoute,
  AppDownloadsIndexRoute: AppDownloadsIndexRoute,
  AppFavoritesIndexRoute: AppFavoritesIndexRoute,
  AppFoldersIndexRoute: AppFoldersIndexRoute,
  AppHistoryIndexRoute: AppHistoryIndexRoute,
  AppMostPlayedIndexRoute: AppMostPlayedIndexRoute,
  AppPlaylistsIndexRoute: AppPlaylistsIndexRoute,
  AppRecentlyAddedIndexRoute: AppRecentlyAddedIndexRoute,
  AppSearchIndexRoute: AppSearchIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppTracksIndexRoute: AppTracksIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  SignInRouteRoute: SignInRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
